import { Component, inject, OnInit } from '@angular/core';
import { ClientService } from '../../../core/services/client/client.service';
import { FormArray, FormControl, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CurrencyVm } from '../../../core/models/currency-vm';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DialogModule } from '@angular/cdk/dialog';
import { DialogComponent } from '../../../shared/components/dialogbox/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ResponseVm } from '../../../core/models/response-vm';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { MatDatepicker,MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';

@Component({
  selector: 'app-client-payment',
  standalone: true,
  imports: [RouterOutlet, MatButtonModule, MatInputModule,
    MatFormFieldModule, ReactiveFormsModule, FormsModule,MatDatepicker,
    MatListModule, MatIconModule, MatProgressSpinner, CommonModule, DialogModule, MatFormFieldModule,
    MatSelectModule,MatDatepickerModule, MatFormFieldModule, MatInputModule
    ,MatNativeDateModule,
    ReactiveFormsModule,MatLabel],
  templateUrl: './client-payment.component.html',
  styleUrl: './client-payment.component.scss'
})
export class ClientPaymentComponent implements OnInit {
  iClientRepository = inject(ClientService);
  localStorage = inject(AesEncDecService);
  dialog = inject(MatDialog);
  paymentForm: FormGroup;
  currencies: CurrencyVm[] = [];
  templateDetails: any[] = [];
  isLoading:false;
  clientName: string;
  companyName: string;
  clientId:string;
  today = new Date(); // Get today's date
  constructor(private fb: FormBuilder) {
    this.paymentForm = this.fb.group({});
    
  }

  ngOnInit(): void {
    const jsonData =this.localStorage?.getData("loginDetails")?.toString() || '{}';
    const dataArray = JSON.parse(jsonData);
    const firstObject = dataArray[0];

      // Extract the data
    this.clientName = firstObject.companyName;
    this.companyName= firstObject.companyName;
    this.clientId=firstObject.cPortalClientDetailsId;
    this.getPaymentTemplates();
     this.getCurrencyList();
  }

  getPaymentTemplates() {
    this.iClientRepository.getPaymentTemplates().subscribe({
      next: data => {
        this.templateDetails = data[0].clientPayTemplateDetails; // Store template details
        this.createFormControls(this.templateDetails); // Populate the form with the first template
        
        console.log(data);
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  getCurrencyList() {
    this.iClientRepository.getCurrencyList().subscribe({ next: data => {
        this.currencies = data;
      },
    });
  } 
  createFormControls(templateDetails: any[]) {
    // Sort templateDetails by sortOrder
    templateDetails.sort((a, b) => a.sortOrder - b.sortOrder);
    templateDetails.forEach(detail => {
      const validators = [];
      if (detail.mandatory) {
        validators.push(Validators.required);
      }
     
      const control = new FormControl('', validators);
      this.paymentForm.addControl(detail.columnName, control);
      this.paymentForm.addControl("clientId", control);
     // this.paymentForm.get('clientId')?.setValue(this.clientId);
 
    });
    
  }



  onSubmit() {
    if (this.paymentForm.valid) {
      isLoading:true;
      const formData = this.paymentForm.value;
        // Add the clientId to the formData object
      formData.clientId = this.clientId;
      const formattedData = {
        Objects: [formData]
      };

      this.iClientRepository.saveClientPayment(formattedData).subscribe({
        next: (response: ResponseVm) => {
          if (response.responseCode === "1000") {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: response.responseMessage,
              },
            });
            isLoading:false;
            this.paymentForm.reset(); // Reset the form after successful submission
            } else {
              this.dialog.open(DialogComponent, {
                minWidth: '300px',
                data: {
                  message: response.responseMessage,
                },
              });
            }
        },
        error: (err) => {
          if (err.error.ResponseMessage) {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: err.error.ResponseMessage,
              },
            });
          }
        }
      });
      console.log(this.paymentForm.value);
    } else {
      this.displayValidationErrors();
      console.error('Form is invalid');
    }
  }

  displayValidationErrors() {
    Object.keys(this.paymentForm.controls).forEach(key => {
      const controlErrors = this.paymentForm.get(key)?.errors || null;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(errorKey => {
          this.dialog.open(DialogComponent, {
            minWidth: '300px',
            data: {
              message: `Validation error in ${key}: ${errorKey}`
            },
          });
          console.error(`Validation error in ${key}: ${errorKey}`);
        });
      }
    });
  }

  isDropdown(columnName: string): boolean {
    const dropdownFields = ['paidCurrency']; // Example fields
    return dropdownFields.includes(columnName);
  }
  isDatePicker(columnName: string): boolean {
    const DatePickerFields = ['paymentDate']; // Example fields
    return DatePickerFields.includes(columnName);
  }
  formControlKeys(): string[] {
    return Object.keys(this.paymentForm.controls);
  }
}